import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { Block, CheckCircleOutline } from '@mui/icons-material'

import { get, post } from '../utils/http';
import { isPrivate } from '../utils/config';

const VerificationEmail = () => {
  const { uniqueToken } = useParams()
  const [emailVerified, setEmailVerified] = useState(false)
  const [loading, setLoading] = useState(true)

  const verifyToken = async () => {
    const data = await get(`Users/bytoken/${uniqueToken}`)
    if (data.length) {
      const userStatus = {id: data[0].id, active: 'True'}
      await post(`Users/updatestatus`, userStatus)
      setEmailVerified(true)
    } else setEmailVerified(false)
    setLoading(false)
  }

  useEffect(() => {
    verifyToken()
  }, [])  // eslint-disable-line

  return (
    <Box className='d-flex flex-column align-items-center justify-content-center' sx={{width: '100vw', height: '100vh'}}>
      {isPrivate &&
        <Typography className='position-absolute' sx={{top: '1rem', left: '1rem'}} variant='caption'>
          Internal
        </Typography>
      }
      {loading
        ? <CircularProgress />
        : <Box className='d-flex flex-column align-items-center p-5 gap-4'>
          {emailVerified
            ? <>
              <CheckCircleOutline sx={{ fontSize: 100 }} color='success' />
              <Typography className='text-center' variant='h5'>
                Your PathomIQ account is verified
              </Typography>
              <Button className='fs-5 px-3' variant="contained" href='../login'>Log in</Button>
            </>
            : <>
              <Block sx={{ fontSize: 100 }} color='error' />
              <Typography className='text-center' variant='h5'>
                Account verification link has been expired or invalid,<br/>please contact admin if your account is created but couldn't verify
              </Typography>
            </>
          }
        </Box>
      }
    </Box>
  )
}

export default VerificationEmail
